module.exports = __webpack_public_path__ + "img/upper-deck-terrace-02.72e05046.jpeg";